import {
  CLEAR_EVENTS_STATE,
  GET_EVENTS_LIST_SUCCESS,
  GET_EVENT_DATA_SUCCESS,
  GET_EVENT_RSVPS_FOR_FILTER_SUCCESS,
  GET_EVENT_RSVPS_SUCCESS,
} from '../actionConstants';

const defaultState = {
  events: [],
  event: {},
  eventRsvps: [],
  eventRsvpsForFilter: [],
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_EVENTS_LIST_SUCCESS:
      return { ...state, events: action?.res?.data };
    case GET_EVENT_DATA_SUCCESS:
      return { ...state, event: action?.res.data };
    case GET_EVENT_RSVPS_SUCCESS:
      return { ...state, eventRsvps: action?.res.data };
    case GET_EVENT_RSVPS_FOR_FILTER_SUCCESS:
      return { ...state, eventRsvpsForFilter: action?.res.data };
    case CLEAR_EVENTS_STATE:
      return defaultState;
    default:
      return state;
  }
};
